import { getProviderFromModel, getDefaultLLMConfig, buildLLMConfig, getModelConfig, isReasoningModel } from './llmConfig';

export const MODEL_PROVIDERS = {
  OPENAI: 'OpenAI',
  ANTHROPIC: 'Anthropic',
  GROQ: 'Groq',
};

export const MODELS = [
  // Anthropic Models
  {
    value: 'claude-opus-4-5-20251101',
    label: 'Claude Opus 4.5',
    provider: MODEL_PROVIDERS.ANTHROPIC,
    description: 'Most capable Claude model',
    tier: 'premium',
  },
  {
    value: 'claude-sonnet-4-5-20250929',
    label: 'Claude Sonnet 4.5',
    provider: MODEL_PROVIDERS.ANTHROPIC,
    description: 'High quality, balanced performance',
    tier: 'premium',
  },
  {
    value: 'claude-sonnet-4-20250514',
    label: 'Claude Sonnet 4',
    provider: MODEL_PROVIDERS.ANTHROPIC,
    description: 'Top-tier Sonnet model',
    tier: 'premium',
  },
  {
    value: 'claude-3-7-sonnet-20250219',
    label: 'Claude 3.7 Sonnet',
    provider: MODEL_PROVIDERS.ANTHROPIC,
    description: 'Latest Sonnet model',
    tier: 'premium',
  },
  {
    value: 'claude-3-5-sonnet-20241022',
    label: 'Claude 3.5 Sonnet',
    provider: MODEL_PROVIDERS.ANTHROPIC,
    description: 'Premium quality responses',
    tier: 'premium',
  },
  {
    value: 'claude-3-5-haiku-20241022',
    label: 'Claude 3.5 Haiku',
    provider: MODEL_PROVIDERS.ANTHROPIC,
    description: 'Fast previous generation',
    tier: 'standard',
  },
  {
    value: 'claude-haiku-4-5-20251001',
    label: 'Claude Haiku 4.5',
    provider: MODEL_PROVIDERS.ANTHROPIC,
    description: 'Fast, cost-effective model',
    tier: 'standard',
  },
  
  // OpenAI Models
  {
    value: 'gpt-5.1',
    label: 'GPT-5.1',
    provider: MODEL_PROVIDERS.OPENAI,
    description: 'Most advanced GPT model',
    tier: 'premium',
  },
  {
    value: 'gpt-5',
    label: 'GPT-5',
    provider: MODEL_PROVIDERS.OPENAI,
    description: 'Next generation GPT',
    tier: 'premium',
  },
  {
    value: 'o3',
    label: 'O3',
    provider: MODEL_PROVIDERS.OPENAI,
    description: 'Advanced reasoning model',
    tier: 'premium',
  },
  {
    value: 'o3-mini',
    label: 'O3 Mini',
    provider: MODEL_PROVIDERS.OPENAI,
    description: 'Compact reasoning model',
    tier: 'standard',
  },
  {
    value: 'o1',
    label: 'O1',
    provider: MODEL_PROVIDERS.OPENAI,
    description: 'Advanced reasoning capabilities',
    tier: 'premium',
  },
  {
    value: 'o1-mini',
    label: 'O1 Mini',
    provider: MODEL_PROVIDERS.OPENAI,
    description: 'Efficient reasoning model',
    tier: 'standard',
  },
  {
    value: 'gpt-4o',
    label: 'GPT-4o',
    provider: MODEL_PROVIDERS.OPENAI,
    description: 'Most capable GPT-4o model',
    tier: 'premium',
  },
  {
    value: 'gpt-4o-mini',
    label: 'GPT-4o Mini',
    provider: MODEL_PROVIDERS.OPENAI,
    description: 'Fast and efficient GPT-4o variant',
    tier: 'standard',
  },
  {
    value: 'gpt-4.1-2025-04-14',
    label: 'GPT-4.1',
    provider: MODEL_PROVIDERS.OPENAI,
    description: 'Latest GPT-4 model',
    tier: 'premium',
  },
  {
    value: 'gpt-4.1-mini-2025-04-14',
    label: 'GPT-4.1 Mini',
    provider: MODEL_PROVIDERS.OPENAI,
    description: 'Latest mini variant',
    tier: 'standard',
  },
  
  // Groq Models
  {
    value: 'meta-llama/llama-4-maverick-17b-128e-instruct',
    label: 'Llama 4 Maverick',
    provider: MODEL_PROVIDERS.GROQ,
    description: 'Advanced Llama 4 with long context',
    tier: 'premium',
  },
  {
    value: 'meta-llama/llama-4-scout-17b-16e-instruct',
    label: 'Llama 4 Scout',
    provider: MODEL_PROVIDERS.GROQ,
    description: 'Ultra-long context Llama 4',
    tier: 'premium',
  },
  {
    value: 'llama-3.3-70b-versatile',
    label: 'Llama 3.3 70B Versatile',
    provider: MODEL_PROVIDERS.GROQ,
    description: 'Advanced general-purpose LLM',
    tier: 'premium',
    recommended: true,
  },
  {
    value: 'llama-3.1-8b-instant',
    label: 'Llama 3.1 8B Instant',
    provider: MODEL_PROVIDERS.GROQ,
    description: 'Fast and efficient',
    tier: 'standard',
  },
  {
    value: 'qwen3-32b',
    label: 'Qwen 3 32B',
    provider: MODEL_PROVIDERS.GROQ,
    description: 'Complex reasoning and multilingual',
    tier: 'premium',
  },
  {
    value: 'deepseek-r1-distill-llama-70b',
    label: 'DeepSeek R1 70B',
    provider: MODEL_PROVIDERS.GROQ,
    description: 'Reasoning-focused model',
    tier: 'premium',
  },
  {
    value: 'mixtral-8x7b-32768',
    label: 'Mixtral 8x7B',
    provider: MODEL_PROVIDERS.GROQ,
    description: 'Fast multilingual model',
    tier: 'standard',
  },
  {
    value: 'gemma2-9b-it',
    label: 'Gemma 2 9B',
    provider: MODEL_PROVIDERS.GROQ,
    description: 'Compact and efficient',
    tier: 'standard',
  },
];

export const DEFAULT_MODEL = 'llama-3.3-70b-versatile';

export const getModelByValue = (value) => {
  return MODELS.find((model) => model.value === value);
};

export const getModelsByProvider = (provider) => {
  return MODELS.filter((model) => model.provider === provider);
};

export const getRecommendedModel = () => {
  return MODELS.find((model) => model.recommended) || MODELS[0];
};

export const getModelDisplayName = (modelValue) => {
  const model = MODELS.find((m) => m.value === modelValue);
  return model ? model.label : modelValue;
};

export const getModelWithConfig = (modelValue) => {
  const model = getModelByValue(modelValue);
  const config = getModelConfig(modelValue);
  return {
    ...model,
    config,
    llmConfig: getDefaultLLMConfig(modelValue),
  };
};

export const createLLMConfig = (modelValue, customParams = {}) => {
  return buildLLMConfig(modelValue, customParams);
};

export { getProviderFromModel, getDefaultLLMConfig, buildLLMConfig, getModelConfig, isReasoningModel };
